import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axios";
import SectionHeading from "./SectionHeading";

// SKELETON LOADER (same size as card)
const GoalCardSkeleton = () => (
  <div className="h-[10rem] pl-4 pr-2 py-3 rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-lg rounded-bl-lg bg-gray-300 animate-pulse" />
);

const AFSAGoals = () => {
  const [sdgs, setSdgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSdgs = async () => {
    try {
      setLoading(true);
      const resp = await axiosInstance.get("/sdgs");
      const data = resp?.data?.data ?? [];
      setSdgs(data);
    } catch (err) {
      console.error("Failed to fetch SDGs:", err);
      // Keep skeleton indefinitely if failed
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSdgs();
  }, []);

  return (
    <div className="general-p-m bg-[#F7F7F7] py-16">
      <SectionHeading
        subtitle={"Driving Progress on"}
        title={"Sustainable Development Goals"}
      />

      <div
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-duration="600"
        className="grid gap-6 mt-12 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
      >
        {loading
          ? [...Array(10)].map((_, i) => <GoalCardSkeleton key={i} />)
          : sdgs.map((goal, index) => (
              <GoalCard
                key={goal._id}
                index={goal.sdgNumber}
                icon={goal.icon}
                title={goal.title}
                bgColor={goal.bgColor}
                delay={index * 100}
              />
            ))}
      </div>
    </div>
  );
};

// CARD COMPONENT — EXACT ORIGINAL DESIGN
const GoalCard = ({ index, icon, title, bgColor, delay }) => {
  const [formattedTitle, setFormattedTitle] = useState("");

  useEffect(() => {
    if (!title) return;

    const words = title.split(" ");

    if (words.length <= 2) {
      const first = words[0] || "";
      const second = words[1] || "\u200B";
      setFormattedTitle(`${first}\n${second}`);
    } else {
      const mid = Math.ceil(words.length / 2);
      const first = words.slice(0, mid).join(" ");
      const second = words.slice(mid).join(" ");
      setFormattedTitle(`${first}\n${second}`);
    }
  }, [title]);

  return (
    <div
      data-aos="zoom-in"
      data-aos-delay={delay}
      data-aos-duration="600"
      data-aos-easing="ease-out"
      data-aos-once="true"
      style={{ backgroundColor: bgColor }}
      className={`flex flex-col items-center ${
        title ? "justify-around" : "justify-center"
      } h-[10rem] pl-4 pr-2 py-3 rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-lg rounded-bl-lg text-white transition-all hover:scale-[102%] duration-200`}
    >
      {title && (
        <div className="flex w-full mx-auto items-start">
          <span className="text-3xl md:text-4xl lg:text-5xl xl:text-4xl font-bold flex-shrink-0">
            {index}
          </span>

          <h3 className="pl-1 m-1 md:mt-2 lg:mt-3 xl:mt-2 font-semibold text-[0.9rem] sm:text-[1rem] md:text-[0.92rem] tracking-wide capitalize text-left w-full whitespace-pre-line leading-tight min-h-[2.8em] flex items-center">
            {formattedTitle}
          </h3>
        </div>
      )}

      <img
        src={icon}
        alt={title}
        className={`${title ? "size-16 mt-2" : "size-[5rem]"}`}
      />
    </div>
  );
};

export default AFSAGoals;

// import React, { useEffect, useState } from "react";
// import SectionHeading from "./SectionHeading";
// import goal_icon1 from "../../../Assets/Images/home/goal/goal_icon (1).png";
// import goal_icon2 from "../../../Assets/Images/home/goal/goal_icon (2).png";
// import goal_icon3 from "../../../Assets/Images/home/goal/goal_icon (3).png";
// import goal_icon4 from "../../../Assets/Images/home/goal/goal_icon (4).png";
// import goal_icon5 from "../../../Assets/Images/home/goal/goal_icon (5).png";
// import goal_icon6 from "../../../Assets/Images/home/goal/goal_icon (6).png";
// import goal_icon8 from "../../../Assets/Images/home/goal/goal_icon (8).png";
// import goal_icon13 from "../../../Assets/Images/home/goal/goal_icon (13).png";
// import goal_icon17 from "../../../Assets/Images/home/goal/goal_icon (17).png";
// import goal_icon18 from "../../../Assets/Images/home/goal/goal_icon (18).png";
// // import goal_icon7 from "../../../Assets/Images/home/goal/goal_icon (7).png";
// // import goal_icon9 from "../../../Assets/Images/home/goal/goal_icon (9).png";
// // import goal_icon10 from "../../../Assets/Images/home/goal/goal_icon (10).png";
// // import goal_icon11 from "../../../Assets/Images/home/goal/goal_icon (11).png";
// // import goal_icon12 from "../../../Assets/Images/home/goal/goal_icon (12).png";
// // import goal_icon14 from "../../../Assets/Images/home/goal/goal_icon (14).png";
// // import goal_icon15 from "../../../Assets/Images/home/goal/goal_icon (15).png";
// // import goal_icon16 from "../../../Assets/Images/home/goal/goal_icon (16).png";

// const goalsData = [
//   {
//     title: "No Poverty",
//     icon: goal_icon1,
//     bgColor: "#AD3D42 ",
//   },
//   {
//     title: "Zero Hunger",
//     icon: goal_icon2,
//     bgColor: "#B0812F",
//   },
//   {
//     title: "Good Health & Well Being",
//     icon: goal_icon3,
//     bgColor: "#307836",
//   },
//   {
//     title: "Quality Education",
//     icon: goal_icon4,
//     bgColor: "#AB050C",
//   },
//   {
//     title: "Gender Equality",
//     icon: goal_icon5,
//     bgColor: "#0181B2",
//   },
//   {
//     title: "Clean Water & Sanitation",
//     icon: goal_icon6,
//     bgColor: "#8E0F18",
//   },
//   {
//     title: "Decent Work & Economic Growth",
//     icon: goal_icon8,
//     bgColor: "#B0582F",
//   },
//   {
//     title: "Climate In Action",
//     icon: goal_icon13,
//     bgColor: "#AD3D42",
//   },
//   {
//     title: "Partnership For The Goals",
//     icon: goal_icon17,
//     bgColor: "#0181B2",
//   },
//   {
//     icon: goal_icon18,
//     bgColor: "#8E0F18",
//   },
//   // {
//   //   title: "Affordable & Clean Energy",
//   //   icon: goal_icon7,
//   //   bgColor: "#3DAD7B",
//   // },
//   // {
//   //   title: "Industry & Infrastructure",
//   //   icon: goal_icon9,
//   //   bgColor: "#303578",
//   // },
//   // {
//   //   title: "Reduce Inequality",
//   //   icon: goal_icon10,
//   //   bgColor: "#AB0576",
//   // },
//   // {
//   //   title: "Substractable Infrastructures",
//   //   icon: goal_icon11,
//   //   bgColor: "#0148B2",
//   // },
//   // {
//   //   title: "Consumption & Production",
//   //   icon: goal_icon12,
//   //   bgColor: "#8E700F",
//   // },
//   // {
//   //   title: "Life Below Water",
//   //   icon: goal_icon14,
//   //   bgColor: "#B0812F",
//   // },
//   // {
//   //   title: "Life On Land",
//   //   icon: goal_icon15,
//   //   bgColor: "#307836",
//   // },
//   // {
//   //   title: "Peace & Justice",
//   //   icon: goal_icon16,
//   //   bgColor: "#AB050C",
//   // },
// ];

// const AFSAGoals = () => {
//   return (
//     <div className="general-p-m bg-[#F7F7F7] py-16 ">
//       <SectionHeading
//         subtitle={"Driving Progress on"}
//         title={"Sustainable Development Goals"}
//       />
//       <div
//         data-aos="fade-up"
//         data-aos-anchor-placement="top-bottom"
//         className="grid gap-6 mt-12 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
//       >
//         {goalsData.map((goal, index) => (
//           <GoalCard
//             delay={index * 80}
//             key={index}
//             index={index + 1}
//             icon={goal.icon}
//             title={goal?.title}
//             bgColor={goal.bgColor}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// // Card component
// const GoalCard = ({ index, icon, title, bgColor, delay }) => {
//   const [formattedTitle, setFormattedTitle] = useState("");

//   useEffect(() => {
//     if (title) {
//       const words = title.split(" ");

//       if (words.length <= 2) {
//         // For 1-2 word titles, add line breaks to force two lines
//         const firstLine = words[0] || "";
//         const secondLine = words[1] || "\u200B"; // zero-width space if no second word
//         setFormattedTitle(`${firstLine}\n${secondLine}`);
//       } else {
//         // For longer titles, split into two roughly equal lines
//         const midPoint = Math.ceil(words.length / 2);
//         const firstLine = words.slice(0, midPoint).join(" ");
//         const secondLine = words.slice(midPoint).join(" ");
//         setFormattedTitle(`${firstLine}\n${secondLine}`);
//       }
//     }
//   }, [title]);

//   return (
//     <div
//       data-aos="zoom-in"
//       data-aos-delay={delay}
//       style={{ backgroundColor: bgColor }}
//       className={`flex flex-col items-center ${
//         title ? "justify-around" : "justify-center"
//       }  h-[10rem] pl-4 pr-2 py-3 rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-lg rounded-bl-lg text-white transition-all hover:scale-[102%] duration-200`}
//     >
//       {title && (
//         <div className="flex w-full mx-auto items-start">
//           <span className="text-3xl md:text-4xl lg:text-5xl xl:text-4xl font-bold text-left flex-shrink-0">
//             {index}
//           </span>
//           <h3 className="pl-1 m-1 md:mt-2 lg:mt-3 xl:mt-2 font-semibold text-[0.9rem] sm:text-[1rem] md:text-[0.92rem] tracking-wide capitalize text-left w-full whitespace-pre-line leading-tight min-h-[2.8em] flex items-center">
//             {formattedTitle}
//           </h3>
//         </div>
//       )}
//       <img
//         src={icon}
//         alt={title}
//         className={`  ${title ? "size-16 mt-2 " : "size-[5rem]"} `}
//       />
//     </div>
//   );
// };

// export default AFSAGoals;
